import parse from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';

type Props = {
  className?: string;
  source: string;
};

export const Html: React.FC<Props> = ({ className, source }: Props) => {
  const processedSource = source.replace(/<p><\/p>/g, '<br/>');
  return (
    <div className={className}>
      {parse(
        sanitizeHtml(processedSource, {
          // eslint-disable-next-line import/no-named-as-default-member
          allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'a']),
          allowedAttributes: { img: ['src', 'alt'], a: ['target', 'href', 'rel'], ol: ['start'] },
          allowedSchemes: ['http', 'https', 'data'],
          // data: が必要なのは埋め込み画像だけで、リンク先としての用途はない。
          // data:text/html への遷移は主要ブラウザが禁止済みだが、その緩和策に依存しないよう href では許可しない。
          allowedSchemesByTag: { a: ['http', 'https'], img: ['http', 'https', 'data'] },
          // sanitize-html@2.17.3 の既定 nonTextTags は xmp などの raw-text 要素を含まないため、
          // <xmp> 内に埋め込まれた <script> や event handler がサニタイズをすり抜けて出力される。
          // 該当する raw-text 要素を nonTextTags に追加し、内部のテキストごと破棄させる。
          nonTextTags: ['script', 'style', 'textarea', 'option', 'xmp', 'iframe', 'noembed', 'noframes', 'noscript'],
          transformTags: {
            a: (tagName: string, attribs: Record<string, string>) => {
              const relValues = new Set(
                (attribs.rel ?? '').split(/\s+/).filter(Boolean).concat(['noreferrer', 'noopener'])
              );
              return {
                tagName,
                attribs: {
                  ...attribs,
                  rel: Array.from(relValues).join(' '),
                },
              };
            },
          },
        })
      )}
    </div>
  );
};
